import { FINANCE_SECTION } from '../../../data/site';

export function FinanceSection() {
  return (
    <section className="finance">
      <div className="container">
        <div className="finance-wrap">
          <div className="section-header-wrap">
            <div className="section-header-left">
              <div data-w-id="3db94b77-99dd-3d32-dd8c-9942f37e250e" className="heading-wrap">
                <h2>{FINANCE_SECTION.title}</h2>
              </div>
              <div className="subtitle-wrap left-small">
                <div className="paragraph-02 text-dark-grey-two">{FINANCE_SECTION.subtitle}</div>
              </div>
            </div>
          </div>
          <div className="finance-main-wrap">
            <div className="finance-row">
              <div data-w-id="1e051d18-d50b-33c5-4686-8e7fc2603875" style={{WebkitTransform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', MozTransform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', msTransform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', transform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', opacity: '0', filter: 'blur(5px)'}} className="finance-card-one">
                <div className="finance-image-wrap">
                  <img src={FINANCE_SECTION.cardOneImage} loading="lazy" alt={FINANCE_SECTION.cardOneImageAlt} className="finance-image" />
                </div>
                <div className="finance-one-content">
                  <div className="finance-one-title-wrap">
                    <div className="text-style-h2 text-white">
                      {FINANCE_SECTION.cardOneHeadline}
                    </div>
                  </div>
                  <a href="/waitlist" className="apple-link w-inline-block">
                    <img src="https://cdn.prod.website-files.com/68f92bd9b64e660d33bc67d7/68fce733fa37ff75e6d64b9e_Apple.svg" loading="lazy" alt="" className="apple-image" />
                  </a>
                </div>
                <div className="finance-line-wrap">
                </div>
              </div>
            </div>
            <div className="finance-row">
              <div className="finance-card-two">
                <div className="finance-two-text-wrap">
                  <div className="text-style-h4">
                    {FINANCE_SECTION.cardTwoTitle}
                  </div>
                  <div className="tag text-dark-grey-two">
                    {FINANCE_SECTION.cardTwoTag}
                  </div>
                </div>
                <div className="finance-two-image-wrap">
                  <img src={FINANCE_SECTION.cardTwoImage} loading="lazy" alt={FINANCE_SECTION.cardTwoImageAlt} className="finance-two-image" />
                </div>
              </div>
              <div className="finance-card-three">
                <div className="finance-three-image-wrap">
                  <img src={FINANCE_SECTION.cardThreeImage} loading="lazy" alt={FINANCE_SECTION.cardThreeImageAlt} className="fit-cover" />
                  <div className="finance-three-image-shadow">
                  </div>
                </div>
                <div className="finance-three-content-wrap">
                  <div className="finance-three-title-wrap">
                    <div className="text-style-h4 text-white">
                      {FINANCE_SECTION.cardThreeHeadline}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
